import { useState, useEffect, useRef, useCallback } from 'react';
import { usePermissions } from './usePermissions';
import api from 'services/api';

export const useSolicitacoesNotifications = () => {
  const { hasPermission } = usePermissions();
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const hasFetchedRef = useRef(false);

  const fetchPendingCount = useCallback(async () => {
    if (!hasPermission('solicitacoes.view')) {
      setPendingCount(0);
      return;
    }

    try {
      setLoading(true);
      const response = await api.get('/access-requests?status=pending&per_page=1');
      const totalCount = response.data.total || 0;
      setPendingCount(totalCount);
    } catch (error) {
      console.error('Erro ao buscar solicitações pendentes:', error);
      setPendingCount(0);
    } finally {
      setLoading(false);
    }
  }, [hasPermission]);

  // Buscar apenas uma vez quando o componente monta
  useEffect(() => {
    if (hasPermission('solicitacoes.view') && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchPendingCount();
    }
  }, [hasPermission, fetchPendingCount]);

  return {
    pendingCount,
    loading,
    refreshCount: fetchPendingCount
  };
};

